export default __webpack_public_path__ + "static/media/fk.4c5bf902.svg";